import { colors } from '../../colors';
var para = {
  textColor: colors.graphite,
  messageColor: colors.graphite
};
export default para;